package antd.datepicker

import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.datePicker(handler: RHandler<DatePickerProps>) = child(DatePickerComponent::class, handler)
fun RBuilder.rangePicker(handler: RHandler<RangePickerProps>) = child(DatePickerComponent.RangePicker as ComponentType<RangePickerProps>, jsObject<RangePickerProps>{}, handler)
fun RBuilder.monthPicker(handler: RHandler<MonthPickerProps>) = child(DatePickerComponent.MonthPicker as ComponentType<MonthPickerProps>,jsObject<MonthPickerProps>{}, handler)
fun RBuilder.weekPicker(handler: RHandler<WeekPickerProps>) = child(DatePickerComponent.WeekPicker as ComponentType<WeekPickerProps>,jsObject<WeekPickerProps>{}, handler)
